import React from 'react';
import Cliser from 'cliser';
// import Config from 'config';
require('style/app.scss');

export default class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  getChildContext() {
    return {
      user: this.state ? this.state.login : null
    };
  }

  componentWillMount() {
    // Open model session
    this.session = Cliser
    .open()
    .listen("DeviceModel", (state) => {
      this.setState({device: state})
    })
    .listen("LoginModel", (state) => {
      this.setState({device: state})
      if (this.state.device && this.state.device.token) { 
        Cliser.DeviceModel.connectServer().then((emit) => {
          emit();
        }).catch((err) => {
          this.context.router.push("/login");
        }) 
      }
    })
  }

  componentWillUnmount() {
    this.session.close();
  }

  render() {
    const ready = this.state.device && this.state.device.serverConnected
      || this.props.location.pathname === "/login"
      || this.props.location.pathname.startsWith("/auth");
    return (
      <div>{ready && this.props.children}</div>
    );
  }
}

App.childContextTypes = {
  user: React.PropTypes.object
};

App.propTypes = {
  error: React.PropTypes.string,
  location: React.PropTypes.object
}

App.contextTypes = {
  router: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./client/App.js